import { render, staticRenderFns } from "./QQPieChart.vue?vue&type=template&id=1beaeb20&"
import script from "./QQPieChart.vue?vue&type=script&lang=js&"
export * from "./QQPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports